<div class="dialog-shell">
  <div class="dialog-accent-line"></div>

  <h2 mat-dialog-title class="dialog-title">{{ data.header }}</h2>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ data.message }}</p>
  </mat-dialog-content>

  <div class="dialog-actions">
    <button mat-button mat-dialog-close class="action-btn cancel-btn">No</button>
    <button mat-button mat-dialog-close cdkFocusInitial class="action-btn confirm-btn" (click)="deleteItem(data)">
      Yes
    </button>
  </div>
</div>